import { ChevronRight } from 'lucide-react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@eo/shared';

import { HoursComposition } from './HoursComposition';
import type { HoursCompositionDialogProps } from './types';

export function HoursCompositionDialog({ totals, children }: HoursCompositionDialogProps) {
  return (
    <Dialog>
      <DialogTrigger
        aria-label="See where the engagement’s hours sit"
        className="group -mx-1.5 -my-1 flex w-fit flex-col gap-1 rounded-8 px-1.5 py-1 text-left transition-colors hover:bg-foreground/[0.06] focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-focus"
      >
        {children}
        <span className="flex items-center gap-0.5 text-xs text-text-tertiary transition-colors group-hover:text-text-primary">
          Where the hours sit
          <ChevronRight aria-hidden className="size-3" />
        </span>
      </DialogTrigger>
      <DialogContent className="sm:max-w-lg">
        <DialogHeader>
          <DialogTitle>Where the hours sit</DialogTitle>
          <DialogDescription>
            How the engagement splits between fixed and variable, and who holds it.
          </DialogDescription>
        </DialogHeader>
        <HoursComposition totals={totals} />
      </DialogContent>
    </Dialog>
  );
}
